import { KYMW1304Component } from './kymw1304.component';

/**
 * Ｐコード一発選定画面の値を管理するクラス
 *
 * @export KYMW1304Model
 * @class KYMW1304Model
 */
export class KYMW1304Model {

  kymw1304Component: KYMW1304Component;

  // 画面バインド用変数
  public pCode: string = <string>'';                                            // Ｐコード
  public enabled = Boolean(false);                                     // 活性フラグ

}
